import { batch } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { agreements, TResponseDto } from '@r1-frontend/api-domru/core-profile/v2/user/agreements';

import { TAppThunkDispatch, TState } from '~/src/store';
import { setAgreements, setStatus } from '~/src/store/actions/agreements';
import { selectIsAuth } from '~/src/store/selectors/auth/selectIsAuth';

const getAgreements = () => async(dispatch: TAppThunkDispatch, getState: () => TState) => {
    const state = getState();
    const isAuth = selectIsAuth(state);

    if (!isAuth) {
        return;
    }

    dispatch(setStatus('loading'));

    const response = await doRequest.coreProfile<TResponseDto>(agreements());

    if (!response.isSuccess) {
        dispatch(setStatus('error'));
        return;
    }

    batch(() => {
        dispatch(setAgreements(response.payload));
        dispatch(setStatus('complete'));
    });
};

export default getAgreements;
